import React, { useEffect, useRef, useState } from 'react'
import { Loader } from './Loader'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import config from '../../config';
import Icon from 'react-multi-date-picker/components/icon';

// normalizes both originalData shapes (object = loan record, array = webhook log) into one consistent structure
const normalizeLoanRow = (row) => {
  const isArrayType = Array.isArray(row?.originalData);

  if (isArrayType) {
    // Type B: webhook/payment log array - use the first (most recent) entry
    const first = row.originalData?.[0] || {};
    return {
      loan_id: first.loan_id,
      loan_amt: first.order_amount,
      start: first.createdAt,       // no true "start" field on webhook logs
      due: first.payment_time,      // no true "due" field either - using payment_time as closest date
      name: first.student_name,
      email: first.student_email,
      mobile: first.student_mobilenumber,
      isWebhookLog: true
    };
  }

  // Type A: normal loan document
  const orig = row?.originalData || {};
  return {
    loan_id: orig.loan_id,
    loan_amt: orig.loan_amt,
    start: orig.start,
    due: orig.due,
    name: orig.student?.name,
    email: orig.student?.email,
    mobile: orig.student?.mobile,
    isWebhookLog: false
  };
};

// Presentational helper only - derives initials for the avatar chip, no state/logic change
const getInitials = (name) => {
  if (!name) return '—';
  const parts = name.trim().split(' ').filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const LoanJourneys = () => {
  const [data, setData] = useState()
  const [loan, setLoan] = useState('undefined')
  const [loan_data, setloanData] = useState()
  const [selection, setSelection] = useState()
  const [totalPages, setTotalPages] = useState()
  const [currentPage, setCurrentPage] = useState(1)
  const [loading, setLoading] = useState(true); // Loading state
  const [loanIdSearch, setLoanIdSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');

  const individual = useSelector((state)=>  state?.Individual?.individual_role)

  const serviceSelect = useRef(null);
  const dailySelect = useRef(null);

  const handlechange = (e)=>{
    setSelection(e.target.value)
  }

  const PAGE_LIMIT = 5; // Number of pages to show before and after current page

  const handlePageClick = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page)
  };

  const handleLoanIdSearch = (e) => {
    setLoanIdSearch(e.target.value);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(loanIdSearch);
      setCurrentPage(1);
    }, 400);
    return () => clearTimeout(timer);
  }, [loanIdSearch]);

  async function fetchData(){
    const token = localStorage.getItem('access_token')
    setLoading(true)

    const searchParam = debouncedSearch ? `&loan_id=${encodeURIComponent(debouncedSearch)}` : '';
    const Respones = await fetch(`${config.apiUrlBetaV2}loan_journey?page=${currentPage}${searchParam}`,{
      method: 'GET',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      },
    })
    if(loan != 'undefined'){
        const loan_data = await fetch(`${config.apiUrlBetaV2}get_waiver/${loan}?percInterest=${Number(dailySelect.current.value)}&serperInterest=${Number(serviceSelect.current.value)}`,{
          method: 'GET',
          headers: {
            'Authorization': token,
            'Content-Type': 'application/json'
          },
        })
        const json_data = await loan_data.json()
        setloanData(json_data.data)
        }
    const json_data = await Respones.json()
    if(Respones.ok){
        setLoading(false)
    }

    setTotalPages(json_data.totalPages)
    setData(json_data.loans)
  }

  const handleFile = async (e)=>{
    const token = localStorage.getItem()
      let Respones = await fetch(`${config.apiUrlBetaV2}mapped_collection?excel=true`,{
        method: 'GET',
        headers: {
          'Authorization': token,  // Replace with your actual token
          'Content-Type': 'application/json'  // Include this if you're sending JSON data
        },
      })
      const json_data = await Respones.json()

      const binaryString = window.atob(json_data.body);  
      const byteArray = new Uint8Array(binaryString.length); 
      for (let i = 0; i < binaryString.length; i++) {
        byteArray[i] = binaryString.charCodeAt(i);
      }
  
      const blob = new Blob([byteArray], { type: 'application/octet-stream' }); 
      const url = window.URL.createObjectURL(blob);
  
      const link = document.createElement('a');
      link.href = url;
      link.download = 'loan_mapping.xlsx'; 
      link.click();
  
      window.URL.revokeObjectURL(url);
  }

  const handlecashfreelink = async(loan_amount, loan_id)=>{
    const token = localStorage.getItem('access_token')
    let postData = {
        loan_id: loan_id,
        link_amount: loan_amount
    }
    const response = await fetch(`${config.apiUrlBetaV2}cashfree_link`, {
        method: 'POST',               // Set the request method to POST
        headers: {
          'Authorization': token,  // Replace with your actual token
          'Content-Type': 'application/json'  // Include this if you're sending JSON data
        },
        body: JSON.stringify(postData) // Convert the data to a JSON string
    });
  }

  const handlecashfree = (event) =>{
    fetchData()
    const serviceValue = serviceSelect.current.value;
    const dailyValue = dailySelect.current.value;
  }
  
  useEffect(()=>{
      if (loan) {
          fetchData();  // Only fetch when `loan` is defined
      }
      },[loan,serviceSelect,dailySelect,selection,currentPage,debouncedSearch])

  const getPageNumbers = () => {
    const pages = [];
    const leftLimit = Math.max(1, currentPage - Math.floor(PAGE_LIMIT / 2));
    const rightLimit = Math.min(totalPages, currentPage + Math.floor(PAGE_LIMIT / 2));

    if (leftLimit > 1) {
        pages.push(1);
        if (leftLimit > 2) pages.push('...'); // Ellipsis for skipped pages
    }

    for (let i = leftLimit; i <= rightLimit; i++) {
        pages.push(i);
    }

    if (rightLimit < totalPages) {
        if (rightLimit < totalPages - 1) pages.push('...'); 
        pages.push(totalPages);
    }

    return pages;
  };

  // Presentational only: 6 placeholder rows while fetchData() is in flight, mirrors table column count
  const SkeletonRows = () => (
    <>
      {Array.from({ length: 6 }).map((_, i) => (
        <tr key={`skeleton-${i}`}>
          {Array.from({ length: 9 }).map((__, j) => (
            <td key={j}>
              <div
                style={{
                  height: 14,
                  borderRadius: 6,
                  background: 'linear-gradient(90deg, #eef0f4 25%, #f7f8fa 37%, #eef0f4 63%)',
                  backgroundSize: '400% 100%',
                  animation: 'loanJourneyShimmer 1.4s ease infinite',
                  width: j === 0 ? '70%' : '85%'
                }}
              />
            </td>
          ))}
        </tr>
      ))}
    </>
  );

  return (
    <>
      <style>{`
        @keyframes loanJourneyShimmer {
          0% { background-position: 100% 50%; }
          100% { background-position: 0 50%; }
        }
        .loan-row:hover { background-color: var(--bs-primary-50, #f5f8ff); }
        .loan-avatar-chip {
          width: 32px;
          height: 32px;
          min-width: 32px;
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.3px;
        }

        /* Search box */
        .loan-search-field {
          position: relative;
          display: flex;
          align-items: center;
          width: 260px;
          max-width: 100%;
        }
        .loan-search-field .loan-search-icon {
          position: absolute;
          left: 14px;
          display: flex;
          align-items: center;
          font-size: 16px;
          color: var(--bs-secondary-color, #8a94a6);
          pointer-events: none;
        }
        .loan-search-field input.loan-search-input {
          width: 100%;
          height: 40px;
          padding: 0 36px 0 40px;
          border-radius: 999px;
          border: 1px solid var(--bs-border-color, #e3e6ec);
          background: var(--bs-body-bg, #fff);
          font-size: 14px;
          transition: border-color .15s ease, box-shadow .15s ease;
        }
        .loan-search-field input.loan-search-input:focus {
          outline: none;
          border-color: var(--bs-primary, #487fff);
          box-shadow: 0 0 0 3px rgba(72, 127, 255, 0.15);
        }
        .loan-search-clear {
          position: absolute;
          right: 10px;
          width: 22px;
          height: 22px;
          border: none;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: var(--bs-secondary-bg, #eef1f5);
          color: var(--bs-secondary-color, #6b7383);
          font-size: 12px;
          line-height: 1;
          cursor: pointer;
        }
        .loan-search-clear:hover {
          background: #e2e6ee;
        }

        /* Pagination */
        .loan-pagination {
          list-style: none;
          margin: 0;
          padding: 0;
        }
        .loan-pagination .loan-page-btn {
          min-width: 34px;
          height: 34px;
          padding: 0 8px;
          border-radius: 8px;
          border: 1px solid transparent;
          font-size: 13px;
          font-weight: 500;
          color: var(--bs-secondary-color, #667085);
          background: transparent;
          text-decoration: none !important;
          transition: background-color .15s ease, color .15s ease, border-color .15s ease;
        }
        .loan-pagination .loan-page-btn:hover:not(.is-disabled):not(.is-active) {
          background: var(--bs-primary-50, #eef3ff);
          color: var(--bs-primary, #487fff);
        }
        .loan-pagination .loan-page-btn.is-active {
          background: var(--bs-primary, #487fff);
          color: #fff;
          box-shadow: 0 4px 10px rgba(72, 127, 255, 0.28);
        }
        .loan-pagination .loan-page-btn.is-disabled {
          opacity: 0.4;
          pointer-events: none;
        }
        .loan-pagination .loan-page-ellipsis {
          color: var(--bs-secondary-color, #98a2b3);
          padding: 0 4px;
        }
      `}</style>

      <div className="card-header d-flex flex-wrap align-items-center justify-content-between gap-3">

        <div className="d-flex flex-wrap align-items-center gap-3">
          <select id='status' className="form-select form-select-sm w-auto" defaultValue="Select Days" onChange={handlechange}>
            <option value="Select Days" disabled>
              Select Days
            </option>
            <option value="0">0</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="All">All</option>
          </select>

          <div className="loan-search-field">
            <span className="loan-search-icon">
              <Icon icon="ion:search-outline" />
            </span>
            <input
              type="text"
              name="loan_id_search"
              className="loan-search-input"
              placeholder="Search Loan ID"
              value={loanIdSearch}
              onChange={handleLoanIdSearch}
            />
            {loanIdSearch && (
              <button
                type="button"
                className="loan-search-clear"
                aria-label="Clear search"
                onClick={() => setLoanIdSearch('')}
              >
                <Icon icon="ion:close-outline" />
              </button>
            )}
          </div>
        </div>

        {/* <div className="d-flex flex-wrap align-items-center gap-3">
          {individual?.loan_details?.export_access === true && (
            <button className="btn btn-sm btn-primary-600" onClick={handleFile}>
              <i className="ri-add-line" /> Download XLSX
            </button>
          )}
        </div> */}
      </div>

      <div className="card-body">
        <div style={{ overflowX: 'auto', maxHeight: '750px', overflowY: 'auto', border: '1px solid var(--bs-border-color, #eceff3)', borderRadius: 12 }}>
          <table className="table bordered-table mb-0">
            <thead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
              <tr>
                <th scope="col">Loan Id</th>
                <th scope="col">Loan Amount</th>
                <th scope="col">Start Date</th>
                <th scope="col">Due Date</th>
                <th scope="col">Allocated Date</th>

                <th scope="col">User Name</th>
                <th scope="col">User Email</th>
                <th scope="col">User Mobile</th>
                <th scope="col">Agency Name</th>
                <th scope="col">Modified By</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <SkeletonRows />
              ) : data && data.length > 0 ? (
                data.map((rawRow, index) => {
                  console.log("rawRow : ",rawRow);
                  const row = normalizeLoanRow(rawRow); // normalize both originalData shapes

                  return (
                    <tr key={index} className="loan-row">
                      <td>
                        <Link to="#" className="text-primary-600 fw-semibold">
                          {row.loan_id || 'N/A'}
                        </Link>
                        {row.isWebhookLog && (
                          <span className="badge bg-primary-50 text-primary-600 ms-8" style={{ fontSize: 10, fontWeight: 500 }}>
                            Webhook
                          </span>
                        )}
                      </td>

                      <td>
                        <div className="d-flex align-items-center">
                          <h6 className="text-md mb-0 fw-medium flex-grow-1">
                            {row.loan_amt ?? 'N/A'}
                          </h6>
                        </div>
                      </td>

                      <td>
                        <div className="d-flex align-items-center">
                          <h6 className="text-md mb-0 fw-medium flex-grow-1 text-secondary-light">
                            {row.start ? new Date(row.start).toLocaleDateString() : 'N/A'}
                          </h6>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <h6 className="text-md mb-0 fw-medium flex-grow-1 text-secondary-light">
                            {row.due ? new Date(row.due).toLocaleDateString() : 'N/A'}
                          </h6>
                        </div>
                      </td>
                            <td>
                        <div className="d-flex align-items-center">
                          <h6 className="text-md mb-0 fw-medium flex-grow-1 text-secondary-light">
                            {rawRow.updatedData.updatedAt ? new Date(rawRow.updatedData.updatedAt).toLocaleDateString() : 'N/A'}
                          </h6>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex align-items-center gap-2">
                          <span className="loan-avatar-chip bg-primary-50 text-primary-600">
                            {getInitials(row.name)}
                          </span>
                          <h6 className="text-md mb-0 fw-medium">
                            {row.name || 'N/A'}
                          </h6>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <h6 className="text-md mb-0 fw-medium flex-grow-1 text-secondary-light">
                            {row.email || 'N/A'}
                          </h6>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <h6 className="text-md mb-0 fw-medium flex-grow-1">
                            {row.mobile || 'N/A'}
                          </h6>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <h6 className="text-md mb-0 fw-medium flex-grow-1">
                            {rawRow.updatedData
                              ? rawRow.originalData?.Agenc_name || rawRow.updatedData?.agencies_id
                              : "NA"}
                          </h6>
                        </div>
                      </td>

                      <td>
                        <div className="d-flex align-items-center">
                          <h6 className="text-md mb-0 fw-medium flex-grow-1">
                            {rawRow?.modifiedByName}
                          </h6>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={9} className="text-center py-40">
                    <div className="d-flex flex-column align-items-center gap-2 text-secondary-light">
                      <Icon icon="ion:search-outline" style={{ fontSize: 24, opacity: 0.5 }} />
                      <span className="fw-medium">No loan journeys found</span>
                      {debouncedSearch && (
                        <span className="text-sm">Try a different Loan ID</span>
                      )}
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-24">
          <span className="text-secondary-light">
            Showing {(currentPage - 1) * 10 + 1} to {Math.min(currentPage * 10, totalPages * 10)} of {totalPages * 10} entries
          </span>
          <ul className="loan-pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
            {/* Previous Button */}
            <li>
              <Link
                className={`loan-page-btn d-flex align-items-center justify-content-center ${currentPage === 1 ? 'is-disabled' : ''}`}
                to="#"
                onClick={() => handlePageClick(currentPage - 1)}
                disabled={currentPage === 1}
                aria-label="Previous page"
              >
                <Icon icon="ep:d-arrow-left" className="text-md" />
              </Link>
            </li>

            {/* Page Numbers */}
            {getPageNumbers().map((page, index) =>
              page === '...' ? (
                <li key={index}>
                  <span className="loan-page-ellipsis">···</span>
                </li>
              ) : (
                <li key={index}>
                  <Link
                    className={`loan-page-btn d-flex align-items-center justify-content-center ${page === currentPage ? 'is-active' : ''}`}
                    to="#"
                    onClick={() => handlePageClick(page)}
                  >
                    {page}
                  </Link>
                </li>
              )
            )}

            {/* Next Button */}
            <li>
              <Link
                className={`loan-page-btn d-flex align-items-center justify-content-center ${currentPage === totalPages ? 'is-disabled' : ''}`}
                to="#"
                onClick={() => handlePageClick(currentPage + 1)}
                disabled={currentPage === totalPages}
                aria-label="Next page"
              >
                <Icon icon="ep:d-arrow-right" className="text-md" />
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
          <div className="modal-content radius-16 bg-base">
            <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Generate Link
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body p-24">
              <form action="#">
                <div className="d-flex flex-wrap align-items-center gap-3 mb-5">
                  <p className="fw-semibold text-gray-500">Service  %:</p>

                  <select id='service' className="form-select form-select-sm w-auto" defaultValue="service"
                    ref={serviceSelect}
                    onChange={handlecashfree}
                  >
                    <option value="service" disabled>
                      Select Service charge discount
                    </option>
                    <option value="0">0%</option>
                    <option value="25">25%</option>
                    <option value="50">50%</option>
                    <option value="75">75%</option>
                    <option value="100">100%</option>
                  </select>
                  <p className="fw-semibold text-gray-500">Daily  %:</p>

                  <select id='daily' className="form-select form-select-sm w-auto" defaultValue="daily" ref={dailySelect} onChange={handlecashfree}>
                    <option value="daily" disabled>
                      Select Defaulted Loans
                    </option>
                    <option value="0">0%</option>
                    <option value="25">25%</option>
                    <option value="50">50%</option>
                    <option value="75">75%</option>
                    <option value="100">100%</option>
                  </select>
                </div>
                <div className="row">
                  <div className="d-flex align-items-center justify-content-between border border-gray-300 bg-gray-50 p-2 rounded shadow-sm">
                    <p className="fw-semibold text-gray-500">Defaulting in days:</p>
                    <p className="text-right text-gray-600">{loan_data?.no_of_days_past_due}</p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border border-gray-300 bg-gray-50 p-2 rounded shadow-sm">
                    <p className="fw-semibold text-gray-500">Total Service Charge Fee:</p>
                    <p className="text-right text-gray-600">{loan_data?.serviceChargeFee}</p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border border-gray-300 bg-gray-50 p-2 rounded shadow-sm">
                    <p className="fw-semibold text-gray-500">Total Daily Charge Fee:</p>
                    <p className="text-right text-gray-600">{loan_data?.dailyLateFee}</p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border border-gray-300 bg-gray-50 p-2 rounded shadow-sm">
                    <p className="fw-semibold text-gray-500">Total Penalty:</p>
                    <p className="text-right text-gray-600">{loan_data?.totalPenalty}</p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border border-gray-300 bg-gray-50 p-2 rounded shadow-sm">
                    <p className="fw-semibold text-gray-500">Total Amount Payable:</p>
                    <p className="text-right text-gray-600">{loan_data?.totalAmountPayable}</p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border border-gray-300 bg-gray-50 p-2 rounded shadow-sm">
                    <p className="fw-semibold text-gray-500">Service Charge Payable:</p>
                    <p className="text-right text-gray-600">{loan_data?.service_waived}</p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border border-gray-300 bg-gray-50 p-2 rounded shadow-sm">
                    <p className="fw-semibold text-gray-500">Daily Charge Payable:</p>
                    <p className="text-right text-gray-600">{loan_data?.waived}</p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border border-gray-300 bg-gray-50 p-2 rounded shadow-sm">
                    <p className="fw-semibold text-gray-500">Total Amount to be generated:</p>
                    <p className="text-right text-gray-600">{loan_data?.waived_total_amount}</p>
                  </div>

                  <div className="d-flex align-items-center justify-content-center gap-3 mt-24">
                    <button
                      type="reset"
                      className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary border border-primary-600 text-md px-48 py-12 radius-8"
                      onClick={() => handlecashfreelink(loan_data?.waived_total_amount, loan_data.loan_id)}
                    >
                      Generate
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default LoanJourneys